/**
 * Mock delay (ms) the in-chat reset prompt waits between the user
 * clicking "Continue" and dispatching the reset. Mirrors the latency
 * of the API-backed implementation we'll layer in next, so the
 * spinner state is exercised during local QA. Pulled out as a named
 * constant so tests can fast-forward via fake timers.
 *
 * Lives in a dedicated constants file (per `.cursor/rules/react/react.mdc`
 * "Component Constants": component files should never export constants).
 */
export const MOCK_RESET_DELAY_MS = 600;
